import React from 'react';

import BlogCategoryPageTemplate from '@/components/route/blog/BlogCategoryPageTemplate';
import { useCaptainBlogAI } from '@/hooks/useCaptainBlogAI';
import getBlogCategoryPosts from '@/services/getBlogCategoryPosts';
import { IBlogPost } from '@/services/types/blog/post.types';
import withRedirect from '@/utility/withRedirect';

export const getServerSideProps = withRedirect(
  { destination: '/blog', permanent: false },
  async ({ params = {} }) => {
    const { categorySlug } = params;
    if (!categorySlug || typeof categorySlug === 'string') {
      throw new Error(
        'No valid slug for blog category post provided. Are all slug parts provided?',
      );
    }
    const hasPageUri = categorySlug.includes('page');
    let pageNumber = 1;
    if (hasPageUri) {
      // page params are the last two elements in the categorySlug array
      const pageParams = categorySlug.splice(-2);
      pageNumber = Number(pageParams.pop());
      if (isNaN(pageNumber)) {
        pageNumber = 1;
      }
    }
    const pageSlug = categorySlug.join('/');
    const slug = categorySlug.pop();
    if (!slug) {
      throw new Error('No slug for blog category post provided');
    }
    const { posts, title, totalPages } = await getBlogCategoryPosts({
      slug,
      page: pageNumber,
    });
    return { props: { slug: pageSlug, currentPage: pageNumber, title, totalPages, posts } };
  },
);

interface IBlogCategoryPageProps {
  currentPage: number;
  posts: IBlogPost[];
  title: string;
  totalPages: number;
  slug: number;
}

const BlogCategoryPage: React.FC<IBlogCategoryPageProps> = ({
  currentPage,
  posts = [],
  slug,
  title,
  totalPages,
}) => {
  useCaptainBlogAI();

  return (
    <BlogCategoryPageTemplate
      categorySlug={slug}
      currentPage={Number(currentPage)}
      posts={posts}
      title={title}
      totalPages={totalPages}
    />
  );
};

export default BlogCategoryPage;
